// extracted by mini-css-extract-plugin
export var card = "_4c-0";
export var content = "_4c-1";
export var contentLoading = "_4c-2";